import React, { useContext } from "react";
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import { AppManContext } from "../../../RoundManContext";
import { useTranslation } from "react-i18next";

const ProFiveNotice = () => {
	const { t } = useTranslation();
	const {
		addProSteps,
		setAddProSteps,
		notiCheck,
		setNotiCheck,
		resultFromProFive,
		setresultFromProFive,
	} = useContext(AppManContext);

	const moveToNextStep = () => {
		setAddProSteps(addProSteps + 1);
	};

	const moveToPrevStep = () => {
		setAddProSteps(addProSteps - 1);
	};

	const handleNotice = (e, type) => {
		setresultFromProFive({ ...resultFromProFive, [type]: e.target.value });
	};

	return (
		<>
			<div className="modal-content noticeSetup">
				<div className="setup-header">
					<div className="title-wrap">
						<p className="desc">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProFiveNotice.title"
							)}
						</p>
					</div>
					<label className="switch">
						<input
							type="checkbox"
							checked={notiCheck}
							onChange={() => setNotiCheck(!notiCheck)}
						/>
						<span className="slider round" />
						<span className="slider-label">
							{t(
								"pages.round.RoundManage.modal.additionalRound.steps.ProFiveNotice.label"
							)}
						</span>
					</label>
				</div>
				<div className="c__card setup-card">
					{notiCheck ? (
						<>
							<div className="f__group">
								<div className="f__control">
									<input
										type="text"
										className="c__input notice-title"
										placeholder={t(
											"pages.round.RoundManage.modal.additionalRound.steps.ProFiveNotice.inputPlaceholder"
										)}
										value={resultFromProFive.title}
										onChange={(e) => handleNotice(e, "title")}
									/>
								</div>
							</div>
							<div className="f__group">
								<div className="f__control">
									<textarea
										className="c__textarea"
										placeholder={t(
											"pages.round.RoundManage.modal.additionalRound.steps.ProFiveNotice.textPlaceholder"
										)}
										value={resultFromProFive.content}
										onChange={(e) => handleNotice(e, "content")}
									/>
									<span className="character-length">0/500</span>
								</div>
							</div>
						</>
					) : (
						<div className="c__noData">
							<CautionIcon />
							<p className="main">
								{t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProFiveNotice.noDataTitle"
								)}
							</p>
							<p className="sub">
								{t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProFiveNotice.noDataText"
								)}
							</p>
						</div>
					)}
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btn__solid" color="gray" onClick={moveToPrevStep}>
					{t("pages.round.RoundManage.modal.additionalRound.steps.ProFiveNotice.prev")}
				</button>
				<button
					type="button"
					className="btn__solid"
					color="primary"
					// onClick={showJudgeDateAlert}
					// onClick={showConfirmAlert}
					// onClick={showExternalAlert}
					onClick={moveToNextStep}
				>
					{t("pages.round.RoundManage.modal.additionalRound.steps.ProFiveNotice.next")}
				</button>
				{/*<button*/}
				{/*	type="button"*/}
				{/*	className="btn__solid"*/}
				{/*	color="primary"*/}
				{/*	onClick={() => setEvaluateSetupModal(false)}*/}
				{/*>*/}
				{/*	확인*/}
				{/*</button>*/}
			</div>
		</>
	);
};

export default ProFiveNotice;
